import axios from '../../_utils/axios';
import store, { DELETE_LOADER, persistor } from '../../../store';
import { format } from '../../../utils/format';

// ----------------------------------------------------------------------

const getInquiry = async (
  setData: React.Dispatch<React.SetStateAction<{
    content: any[];
    totalElements: number;
    totalPages: number;
  }>>,
  id: string,
  startDate: Date,
  endDate: Date,
  interval: string,
  { page, size }: { page: number, size: number }
) => {
  const start = format(startDate, interval === 'setting' ? 'daily' : interval, 'start');
  const end = format(endDate, interval === 'setting' ? 'daily' : interval, 'end');

  return await axios.get(`data-inquiry/iot-devices/${id}/search-page?start=${encodeURIComponent(start)}&end=${encodeURIComponent(end)}&page=${page}&size=${size}`)
    .then((response) => {
      let data = response.data.data;
      if ( data.content.length > 0 ) {
        const content = data.content.map((row: any) => {
          if ( row.waterQualities.length > 0 ) {
            row.waterQualities.forEach((value: any) => {
              Object.assign(row, {
                [`${value.name} (${value.unit})`]: value.measuredValue,
                [`${value.name}alarm`]: value.alarm === 'LOW' ? '미만' : value.alarm === 'HIGH' ? '초과' : '정상',
                [`${value.name}status`]: value.status === 'ERROR' ? '에러' : '정상'
              });
            });
          }
          if ( row.waterQualityPredictions.length > 0 ) {
            row.waterQualityPredictions.forEach((value: any) => {
              Object.assign(row, {
                [`${value.name} (${value.unit})`]: value.predictionValue,
                [`${value.name}alarm`]: value.alarm === 'LOW' ? '미만' : value.alarm === 'HIGH' ? '초과' : '정상'
              });
            });
          } else if ( store.getState().device.waterQualityPredictions.length > 0 ) {
            store.getState().device.waterQualityPredictions.forEach((value: any) => {
              Object.assign(row, {
                [`${value.name} (${value.unit})`]: null,
                [`${value.name}alarm`]: null,
                waterQualityPredictions: [
                  ...row.waterQualityPredictions,
                  {
                    name: value.name,
                    unit: value.unit,
                    alarm: null,
                    measuredValue: null,
                  }
                ]
              });
            });
          }
          return row;
        });
        data.content = content;
      }
      return setData(data);
    })
    .catch((error) => {
      const code = error.response.data.code;
      
      if ( error.code === 'ERR_BAD_RESPONSE' ) {
        persistor.purge();
        return window.location.href = '/alert';
      } else if ( code === 'ERR-001' || code === 'ERR-REISSUE' ) {
        persistor.purge();
        return window.location.href = '/login';
      }
    })
    .finally(() => store.dispatch( DELETE_LOADER() ));
};

export default getInquiry;